module.exports = __webpack_public_path__ + "static/media/Interstate-Black.363d3a22.otf";